import { useState } from "react";
import "./AdminIntroBanners.css";

function AdminIntroBanners({
  banner,
  onClose,
  onSalvar
}) {
  const [arquivo, setArquivo] =
    useState(null);

  const [preview, setPreview] =
    useState(null);

  const [salvando, setSalvando] =
    useState(false);

  const handleSelecionarImagem = (
    e
  ) => {
    const file =
      e.target.files?.[0];

    if (!file) return;

    setArquivo(file);

    const reader =
      new FileReader();

    reader.onload = (event) => {
      setPreview(
        event.target.result
      );
    };

    reader.readAsDataURL(file);
  };

  const handleSalvar = async () => {
    if (!arquivo) {
      alert(
        "Selecione uma imagem."
      );
      return;
    }

    try {
      setSalvando(true);

      const formData =
        new FormData();

      formData.append(
        "imagem",
        arquivo
      );

      const uploadResponse =
        await fetch(
          "https://app.eliandroalimentos.com.br/api/imagem/upload",
          {
            method: "POST",
            body: formData,
          }
        );

      const uploadData =
        await uploadResponse.json();

      if (!uploadResponse.ok) {
        throw new Error(
          uploadData.message ||
          "Erro ao fazer upload"
        );
      }

      const editarResponse =
        await fetch(
          "https://app.eliandroalimentos.com.br/api/home_media/editarimagembanner",
          {
            method: "PUT",
            headers: {
              "Content-Type":
                "application/json",
            },
            body: JSON.stringify({
              id: banner.id,
              imagem:
                uploadData.caminho,
            }),
          }
        );

      const editarData =
        await editarResponse.json();

      if (
        !editarResponse.ok
      ) {
        throw new Error(
          editarData.message ||
          "Erro ao atualizar banner"
        );
      }

      if (onSalvar) {
        onSalvar({
          ...banner,
          imagem:
            uploadData.caminho,
        });
      }

      onClose();

    } catch (error) {
      console.error(error);

      alert(
        error.message ||
        "Erro ao salvar"
      );
    } finally {
      setSalvando(false);
    }
  };

  const handleRemoverImagem = async () => {
    const confirmar = window.confirm(
      "Deseja remover a imagem deste banner?"
    );

    if (!confirmar) return;

    try {
      setSalvando(true);

      const response =
        await fetch(
          "https://app.eliandroalimentos.com.br/api/home_media/editarimagembanner",
          {
            method: "PUT",
            headers: {
              "Content-Type":
                "application/json",
            },
            body: JSON.stringify({
              id: banner.id,
              imagem: "",
            }),
          }
        );

      const data =
        await response.json();

      if (!response.ok) {
        throw new Error(
          data.message ||
          "Erro ao remover imagem"
        );
      }

      if (onSalvar) {
        onSalvar({
          ...banner,
          imagem: "",
        });
      }

      onClose();
    } catch (error) {
      console.error(error);

      alert(
        error.message ||
        "Erro ao remover imagem"
      );
    } finally {
      setSalvando(false);
    }
  };


  return (
    <div className="adminIntroBanner-container">

      <div className="adminIntroBanner-header">
        <h2>
          Editar Banner
        </h2>

        <button
          className="adminIntroBanner-fechar"
          onClick={onClose}
        >
          ✕
        </button>
      </div>

      <div className="adminIntroBanner-conteudo">

        {/* IMAGEM ATUAL */}
        <div className="adminIntroBanner-bloco">
          <h3>
            Imagem Atual
          </h3>

          <div className="adminIntroBanner-previewBanner">
            <img
              src={banner.imagem}
              alt=""
            />
          </div>

          <button
            type="button"
            className="adminIntroBanner-btnRemover"
            onClick={handleRemoverImagem}
            disabled={salvando}
          >
            ✕ Remover imagem
          </button>
        </div>

        {/* NOVA IMAGEM */}
        <div className="adminIntroBanner-bloco">
          <h3>
            Nova Imagem (7090 × 2000 px  ou  2008 × 2362 px) .jpg
          </h3>

          <input
            type="file"
            accept="image/*"
            onChange={
              handleSelecionarImagem
            }
          />

          {preview && (
            <div className="adminIntroBanner-previewOriginal">
              <img
                src={preview}
                alt=""
              />
            </div>
          )}
        </div>

        {/* SIMULAÇÃO */}
        {preview && (
          <div className="adminIntroBanner-bloco">
            <h3>
              Como ficará no site
            </h3>

            <div className="adminIntroBanner-previewBanner">
              <img
                src={preview}
                alt=""
              />
            </div>
          </div>
        )}

      </div>

      <div className="adminIntroBanner-footer">

        <button
          className="adminIntroBanner-btnCancelar"
          onClick={onClose}
        >
          Cancelar
        </button>

        <button
          className="adminIntroBanner-btnSalvar"
          onClick={handleSalvar}
          disabled={salvando}
        >
          {salvando
            ? "Salvando..."
            : "Salvar"}
        </button>

      </div>
    </div>
  );
}

export default AdminIntroBanners;